<template>
    <div class="booking-history-index">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square slot="cls_column"
                slot-scope="props"
                :name="props.row.transaction"
                :length="1"
                :color="props.row.transaction == trans('bookings.label.transaction_buy') ? '2' : '15'"
            >
            </colored-letter-square>
        </v-client-table>
    </div>
</template>

<script>
import {EventBus} from '../eventbus';
import { Event } from 'vue-tables-2';

export default {
    props: [
        'client',
        'license',
    ],

    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'booking_date', 'transaction', 'license_amount'],
            options: {
                headings: {
                    cls_column: '',
                    license_amount: this.trans('bookings.label.license_amount'),
                    transaction: this.trans('bookings.label.transaction'),
                    booking_date: this.trans('bookings.label.booking_date'),
                },
                orderBy: {
                    column: 'id',
                    ascending: true,
                },
                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },
                sortable: [
                    'booking_date',
                    'transaction',
                    'license_amount'
                ],
            }
        };
    },

    methods: {
        fetch() {
            axios.get(this.route('tenantapi.bookings.history', {'client': this.client.id, 'license': this.license.id}))
                 .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },

    created() {
        this.fetch();

        var filter = this.debounce((query) => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },
};
</script>
